import React from 'react';
import {Text, View} from 'react-native';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import {useUserStore} from '../../store/UserStore';
import {styles} from './styles';

const TemporaryPasswordBanner = () => {
  const temporaryPasswordLogin = useUserStore(state => state.temporaryPasswordLogin);

  if (!temporaryPasswordLogin) {
    return null;
  }

  return (
    <View style={styles.container}>
      <FontAwesome name="exclamation-circle" size={16} color="#A86A00" />
      <Text style={styles.text}>
        Acesso limitado: você está usando uma senha temporária. Algumas ações
        estão indisponíveis até a troca da senha.
      </Text>
    </View>
  );
};

export default TemporaryPasswordBanner;
